module.exports = __webpack_public_path__ + "static/media/cnd.2f38d687.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/cnd.jpg
// module id = 729
// module chunks = 0